<template>
  <div>
    <TheBuCommonHeader />
    <main class="pt-[4.375rem]">
      <slot />
    </main>
    <TheTeCommonBizFooter />
  </div>
</template>

<script setup lang="ts">
import TheBuCommonHeader from '~/components/Bu/BuCommon/Header/TheBuCommonHeader/TheBuCommonHeader.vue'
import TheTeCommonBizFooter from '~/components/Te/TeCommon/Footer/TheTeCommonBizFooter.vue'

useHead({
  htmlAttrs: {
    'data-theme': 'techacademy',
  },
})
</script>

